<div *ngIf="chartConfig$ | async as chartConfig" class="mb-2">
  <app-websites-apps-by-risk-management-chart
    [config]="chartConfig"
    *ngIf="chartConfig.data.length && chartConfig.data.length !== 0; else emptyState"
  ></app-websites-apps-by-risk-management-chart>
  <ng-template #emptyState>
    <table-empty-state [config]="emptyStateConfig$ | async"></table-empty-state>
  </ng-template>
</div>
